"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.select = exports.FailureStatus = exports.SuccessStatus = exports.PendingStatus = exports.IdleStatus = exports.Status = void 0;
const logPromise_1 = __importDefault(require("../util/logPromise"));
const useIsMountedRef_1 = __importDefault(require("./useIsMountedRef"));
function useStatus(react, promise, resetOnChange = false) {
    const isMountedRef = (0, useIsMountedRef_1.default)(react);
    const [status, setStatus] = react.useState(new IdleStatus(undefined));
    const handlePromise = react.useCallback((promiseToHandle, label) => {
        if (resetOnChange) {
            setStatus(new PendingStatus(undefined));
        }
        else {
            setStatus((oldStatus) => new PendingStatus(oldStatus.value));
        }
        return (0, logPromise_1.default)(label !== null && label !== void 0 ? label : 'Handle promise', promiseToHandle).then(result => {
            if (!isMountedRef.current) {
                return result;
            }
            setStatus(new SuccessStatus(result));
            return result;
        }, error => {
            if (!isMountedRef.current) {
                return undefined;
            }
            setStatus((oldStatus) => new FailureStatus(error, oldStatus.value));
            return undefined;
        });
    }, [isMountedRef, resetOnChange]);
    react.useEffect(() => {
        if (promise) {
            handlePromise(promise, 'Handle promise from useStatus(React, promise)');
        }
    }, [promise, handlePromise]);
    return {
        status,
        value: status.value,
        setStatus,
        handlePromise,
        isPending: status instanceof PendingStatus,
        isIdle: status instanceof IdleStatus,
        error: status.error,
    };
}
exports.default = useStatus;
class Status {
    constructor(type, value) {
        this.type = type;
        this.value = value;
    }
}
exports.Status = Status;
class IdleStatus extends Status {
    constructor(value) {
        super('idle', value);
    }
}
exports.IdleStatus = IdleStatus;
class PendingStatus extends Status {
    constructor(value) {
        super('pending', value);
    }
}
exports.PendingStatus = PendingStatus;
class SuccessStatus extends Status {
    constructor(value) {
        super('success', value);
    }
}
exports.SuccessStatus = SuccessStatus;
class FailureStatus extends Status {
    constructor(error, value) {
        super('failure', value);
        this.error = error;
    }
}
exports.FailureStatus = FailureStatus;
function select(status, outputs) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    if (status instanceof IdleStatus)
        return (_b = (_a = outputs.idle) !== null && _a !== void 0 ? _a : outputs.fallback) !== null && _b !== void 0 ? _b : null;
    if (status instanceof PendingStatus)
        return (_d = (_c = outputs.pending) !== null && _c !== void 0 ? _c : outputs.fallback) !== null && _d !== void 0 ? _d : null;
    if (status instanceof SuccessStatus)
        return (_f = (_e = outputs.success) !== null && _e !== void 0 ? _e : outputs.fallback) !== null && _f !== void 0 ? _f : null;
    if (status instanceof FailureStatus)
        return (_h = (_g = outputs.failure) !== null && _g !== void 0 ? _g : outputs.fallback) !== null && _h !== void 0 ? _h : null;
    return (_j = outputs.fallback) !== null && _j !== void 0 ? _j : null;
}
exports.select = select;
